export interface SaveDraft {
    categoryId: number;
    subCategory: string;
    draftId?: number;
    draftData: string;
}
